export const PAYMENT_INFO_REQUEST = "PAYMENT_INFO_REQUEST";
export const PAYMENT_INFO_SUCCESS = "PAYMENT_INFO_SUCCESS";
export const PAYMENT_INFO_FAIL = "PAYMENT_INFO_FAIL";
export const PAYMENT_INFO_RESET = "PAYMENT_INFO_RESET";
